import HelpHand from './helpHand';

export default class HelpPopup extends Phaser.GameObjects.Sprite {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser.GameObjects.Sprite
   */
  constructor(scene, popupGroup, animData) {
    let width = scene.cameras.main.width;
    let height = scene.cameras.main.height;
    super(scene, width / 2, height / 2, 'popup');
    this.setDepth(30);
    this.overlay = scene.add.image(0, 0, 'white');
    this.overlay.setOrigin(0, 0);
    this.overlay.setDisplaySize(width, height);
    this.overlay.setDepth(this.depth - 5);
    this.overlay.tint = '#000000';
    this.overlay.alpha = 0;

    this.scene = scene;
    this.paddingX = 350;
    this.paddingY = 230;
    this.setOrigin(0.5);
    this.scaleX = 1.2;
    this.scaleY = 1.2;
    this.alpha = 0;
    this.active = false;
    this.emitter = new Phaser.Events.EventEmitter();

    popupGroup.add(this, true);
    const screenX = scene.cameras.main.width / 2;
    const screenY = scene.cameras.main.height / 2;
    // this.title = scene.add.bitmapText(
    //   screenX,
    //   screenY - 185,
    //   'HelloHeadline',
    //   'How To Play'
    // );

    let localisation = scene.cache.json.get('localisation');

    this.title = scene.add.text(screenX, screenY - 185, localisation["how_to_play"][window.language].text, {fontFamily: localisation["how_to_play"][window.language].font});

    let title = this.title;
    this.title.setFontSize(Number.parseFloat(localisation["how_to_play"][window.language].size));
    this.title.setPadding(0,20,0,20);
    title.setOrigin(0.5);
    popupGroup.add(title);
    title.alpha = 0;
    title.setDepth(this.depth + 1);

    this.playBtn = scene.add.sprite(
      screenX + this.paddingX,
      screenY + this.paddingY,
      'playBtn'
    );
    let playBtn = this.playBtn;
    playBtn
      .setInteractive({ useHandCursor: true })
      .on('pointerdown', () => this.handlePlayButtonDown());
    playBtn.alpha = 0;
    popupGroup.add(playBtn);
    playBtn.setDepth(this.depth + 1);

    this.bg = scene.add.image(screenX, screenY + 20, animData.steps[0].image);
    this.bg.setDepth(this.depth + 2);
    this.bg.alpha = 0;
    this.animData = animData;
    this.helpIdx = 0;
    this.helpHand = new HelpHand(scene, screenX, screenY + 150, this.bg);
    this.helpHand.emitter.on('stepComplete', () => this.nextHelp(), this);
    popupGroup.add(this.helpHand);
    this.helpHand.setDepth(this.depth + 2);
    this.helpHand.alpha = 1;
  }

  nextHelp() {
    this.bg.setTexture(this.animData.steps[this.helpIdx].image);
    this.helpHand.setAnims(this.animData.steps[this.helpIdx].anims);
    this.helpHand.start();
    this.helpIdx = (this.helpIdx + 1) % this.animData.steps.length;
  }

  show(scene, animate = true) {
    if (this.btnTween !== undefined) {
      this.btnTween.stop();
      this.btnTween = undefined;
    }

    this.active = true;
    if (animate) {
      this.scaleX = 1.2;
      this.scaleY = 1.2;

      scene.tweens.add({
        targets: this.overlay,
        alpha: 0.5,
        ease: 'Cubic',
        duration: 150
      });

      this.btnTween = scene.tweens.add({
        targets: [this, this.title, this.playBtn, this.bg],
        alpha: 1,
        scaleX: 1,
        scaleY: 1,
        ease: 'Cubic',
        duration: 150,
        // delay: 50,
        onComplete: () => {
          this.onShown();
        }
      });
    } else {
      this.overlay.alpha = 0.5;
      this.alpha = 1;
      this.title.alpha = 1;
      this.playBtn.alpha = 1;
      this.bg.alpha = 1;
      this.scaleX = 1;
      this.scaleY = 1;
      this.onShown();
    }
  }

  onShown() {
    if (this.emitter !== undefined) {
      this.emitter.emit('gamePaused');
    }

    if (this.helpHand === undefined) {
      this.helpHand = new HelpHand(this.scene, screenX, screenY + 150, this.bg);
    }

    this.nextHelp();
  }

  onHidden() {
    this.helpHand.resetAnims();
  }

  hide(scene) {
    scene.tweens.add({
      targets: this.overlay,
      alpha: 0,
      ease: 'Cubic',
      duration: 150
    });

    if (this.btnTween !== undefined) {
      this.btnTween.stop();
      this.btnTween = undefined;
    }

    scene.tweens.add({
      targets: [this, this.title, this.playBtn, this.bg],
      scaleX: 1,
      scaleY: 1,
      alpha: 0,
      ease: 'Cubic',
      duration: 150,
      onComplete: () => {
        this.onHidden();
      }
    });
    this.active = false;
  }

  handlePlayButtonDown() {
    this.scene.paused = false;
    if (this.emitter !== undefined) {
      this.emitter.emit('gameResumed');
    }
    this.hide(this.scene);
  }

  handleMuteButtonDown() {
    this.scene.mute = !this.scene.mute;
  }

  handleHelpButtonDown() {
    // do something helpy
  }

  destroy() {
    super.destroy();
  }
}
